var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"move-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAnimation),expression:"showAnimation"}],staticClass:"player-container",class:{'justify-center d-flex':_vm.showAnimation},style:({ marginTop: _vm.windowTop+'px' })},[_c('div',{staticClass:"lottie-player",attrs:{"id":"player"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }